import { render, staticRenderFns } from "./BFPAReplacementView.vue?vue&type=template&id=7e24ab0e&scoped=true&"
import script from "./BFPAReplacementView.vue?vue&type=script&lang=js&"
export * from "./BFPAReplacementView.vue?vue&type=script&lang=js&"
import style0 from "./BFPAReplacementView.vue?vue&type=style&index=0&id=7e24ab0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e24ab0e",
  null
  
)

export default component.exports